import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import NavbarTwo from "../components/NavbarTwo";
import FooterTwo from "../components/FooterTwo";
import MemberInscription from "../pages/MemberInscription";
import FooterOne from "./FooterOne";

const PartnerShipArea = () => {
  return (
    <>
      <div>
        <NavbarTwo />
        <Breadcrumb title={"Devenir Membre"} />
        <div className="mt-6" style={{  marginTop: "70px"}}>
        <MemberInscription/>
        </div>

        <FooterTwo />
      </div>
    </>
  );
};

export default PartnerShipArea;
